module.exports = __webpack_public_path__ + "img/pretty-sky.c1cec559.png";